// SPDX-License-Identifier: AGPL-3.0-or-later
import asset0 from '@app/media/images/badges/server/boost-0.svg';
import asset1 from '@app/media/images/badges/server/boost-1.svg';
import asset2 from '@app/media/images/badges/server/boost-2-dark.svg';
import asset3 from '@app/media/images/badges/server/boost-2-light.svg';
import asset4 from '@app/media/images/badges/server/boost-3-dark.svg';
import asset5 from '@app/media/images/badges/server/boost-3-light.svg';
import asset6 from '@app/media/images/badges/server/community-boosted.svg';
import asset7 from '@app/media/images/badges/server/community-dark.svg';
import asset8 from '@app/media/images/badges/server/community-light.svg';
import asset9 from '@app/media/images/badges/server/crown.svg';
import asset10 from '@app/media/images/badges/server/discoverable-boosted.svg';
import asset11 from '@app/media/images/badges/server/discoverable-dark.svg';
import asset12 from '@app/media/images/badges/server/discoverable-light.svg';
import asset13 from '@app/media/images/badges/server/new-here.svg';
import asset14 from '@app/media/images/badges/server/partnered.svg';
import asset15 from '@app/media/images/badges/server/staff.svg';
import asset16 from '@app/media/images/badges/server/verified.svg';

export const SERVER_BADGE_ASSETS = Object.freeze({
	'boost-0': asset0,
	'boost-1': asset1,
	'boost-2-dark': asset2,
	'boost-2-light': asset3,
	'boost-3-dark': asset4,
	'boost-3-light': asset5,
	'community-boosted': asset6,
	'community-dark': asset7,
	'community-light': asset8,
	'crown': asset9,
	'discoverable-boosted': asset10,
	'discoverable-dark': asset11,
	'discoverable-light': asset12,
	'new-here': asset13,
	'partnered': asset14,
	'staff': asset15,
	'verified': asset16,
});
